import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  afterRenderEffect,
  inject,
  viewChild,
} from '@angular/core';
import { ToastService } from './toast.service';

// El aviso va como popover (top layer) para verse también sobre los <dialog> modales, como el del
// Comité de Vigilancia; se vuelve a mostrar en cada aviso para quedar encima del último abierto.
@Component({
  selector: 'app-toasts',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (toasts.actual(); as t) {
      <div
        #contenedor
        popover="manual"
        class="toast toast-end toast-bottom z-50 m-0 mb-8 p-0 border-0 overflow-visible"
        aria-live="polite"
      >
        <div role="status" class="alert {{ t.clase }}">
          <i class="{{ t.icono }} text-xl" aria-hidden="true"></i><span>{{ t.mensaje }}</span>
        </div>
      </div>
    }
  `,
})
export class ToastsComponent {
  protected toasts = inject(ToastService);
  private contenedor = viewChild<ElementRef<HTMLElement>>('contenedor');

  constructor() {
    afterRenderEffect(() => {
      this.toasts.actual();
      const el = this.contenedor()?.nativeElement;
      // jsdom no implementa popover.
      if (!el?.showPopover) return;
      if (el.matches(':popover-open')) el.hidePopover();
      el.showPopover();
    });
  }
}
